// React
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

// 3rd party libs
// import FloatingLabelInput from "react-floating-label-input";
import toast from "react-hot-toast";
import cookie from "react-cookies";
import { db } from "../../../../Firebase/firebase";

// Utilities
// import { handleInput, handleKeyPress } from "../../../../Others/eventHandlers";
import { verifyOtp } from "../../../../Request/LoginRequests";
import {
  saveAddress,
  saveUser,
  setCurrentLocation,
} from "../../../../Redux/Actions/userActions";
import { isEmpty } from "../../../../Others/functions";
import Input from "../../../../Others/Input";

export default function Verify({ phn, setState }) {
  const cart = useSelector((state) => state.user.cart);
  const cur = useSelector((state) => state.user.currentLocation);

  const [otp, setotp] = useState("");
  const [load, setLoad] = useState(false);

  const dispatch = useDispatch();

  function handleVerifyOtp() {
    setLoad(true);
    verifyOtp(phn, otp)
      .then((res) => {
        toast.success("Otp Verified");

        // If New User: Majority cases
        if (res.newUser) {
          document.getElementById("cartSignUpSpan").click();
          setState("cartSignUpSpan");
        }
        // Exisitng User
        else {
          document.getElementById("closeVerify").click();
          setTimeout(() => dispatch(saveUser(res.user)), 300); // save user
          dispatch(saveAddress(res.address)); // save user address

          // if empty current location empty: accesses via link
          if (isEmpty(cur)) {
            dispatch(
              setCurrentLocation(
                res.address?.find((el) => el.primary === "true")
              )
            );
          } else {
            dispatch(setCurrentLocation({ ...cur, name: res.user.name }));
          }

          db.collection("Users").doc(res.user.userHash).set({ cart: cart }); // save current cart online

          // save user info in cookie
          cookie.save("uid", res.user.userHash, {
            path: "/",
            expires: new Date(new Date().setDate(new Date().getDate() + 360)),
          });

          // delete visitor cookie
          if (cookie.load("visitor")) cookie.remove("visitor");
        }
      })
      .catch((err) => toast.error(err))
      .finally(() => {
        setLoad(false);
      });
  }
  return (
    <div
      className="offcanvas offcanvas-bottom bg-tr h-auto"
      tabIndex="-1"
      id="cartVerify"
    >
      <div
        className="bi bi-x-circle fs-lg mx-auto text-white"
        id="closeVerify"
        data-bs-dismiss="offcanvas"
      ></div>
      <div className="p-4 round-top text-light bg-orange fw-bold fs-3 py-2">
        <span className="bi bi-unlock-fill me-2 fs-1"></span>
        OTP - <span className="fs-6 fw-light">{phn}</span>
      </div>

      <div className="px-4 py-2 bg-white">
        {/* OTP input */}
        <div className="pt-2 mt-3">
          <Input
            label="OTP"
            placeholder="Enter 6-digit OTP"
            value={otp}
            onChange={(e) => setotp(e.target.value)}
            style={{ pb: 0.5 }}
            fontsize={20}
            dotPrecision={0}
            isAllowed={({ value }) =>
              (value > 0 && value < Math.pow(10, 6)) || value === ""
            }
          />
        </div>
        <br />
        <button
          className="btn-cnf btn-orange w-100 fs-5 py-1"
          disabled={load || !/^[1-9]{1}[0-9]{5}$/.test(otp)}
          onClick={handleVerifyOtp}
        >
          {load ? "Verifying..." : "Verify OTP"}
        </button>
        <button
          className="btn-cnf w-100 fs-5 py-1 mt-2"
          onClick={() => {
            document.getElementById("cartLoginSpan").click();
            setState("cartLoginSpan");
          }}
        >
          Change Phone No.
        </button>
      </div>
    </div>
  );
}
